import React, { useEffect, useState } from 'react';
import CreateNewLineCar from 'src/components/CreateNewSearch/CreateNewLineCar';
import CreateNewLineItem from 'src/components/CreateNewSearch/CreateNewLineItem';
import CreateNewLineHotel from 'src/components/CreateNewSearch/CreateNewLineHotel';
import CreateNewLineVacation from 'src/components/CreateNewSearch/CreateNewLineVacation';
import CreateNewLineFerry from 'src/components/CreateNewSearch/CreateNewLineFerry';
import CreateNewLineCruise from 'src/components/CreateNewSearch/CreateNewLineCruise';
import CreateNewLineSolution from 'src/components/CreateNewSearch/CreateNewLineSolution';
import CreateNewLineCyberPrice from 'src/components/CreateNewSearch/CreateNewLineCyberPrice';
import CreateNewLineAutopart from 'src/components/CreateNewSearch/CreateNewLineAutopart';
import CreateNewLineDrug from 'src/components/CreateNewSearch/CreateNewLineDrug';
import Spin from 'src/components/common/Spin';
import { AppIdResponse, getAppId } from 'src/api/applicationFilter';
import VERTICALS from 'src/enums/Verticals';

export type CreateNewLineViewProps = {
  verticalIdN?: number;
  verticalName?: string;
  searchName?: string;
  jobId?: any;
  addLineItem: any;
  fromPage?: string;
};

const CreateNewLineView: React.FC<CreateNewLineViewProps> = ({
  addLineItem,
  verticalName,
  searchName,
  jobId,
  fromPage,
  verticalIdN,
}: CreateNewLineViewProps) => {
  const [fields, setFields] = useState<any>([]);

  useEffect(() => {
    setTimeout(() => {
      const fetch = async () => {
        const bAdminMode: boolean = localStorage.getItem('bAdminMode') === 'true';
        const response: AppIdResponse = await getAppId(bAdminMode);
        setFields(response.vertical);
      };
      fetch();
    }, 0);
  }, []);

  const getSearchWidget = (verticalIdN: number | undefined, verticalName: string | undefined, fields: any) => {
    const verticalId = String(verticalIdN ?? '0');
    const fieldConfigurable = fields.find((field: any) => field.ID === verticalId && field.config);
    const veticalData = fields.find((field: any) => field.ID === verticalId && field.raname);
    const sRaName = veticalData ? veticalData.raname : '';

    if (fieldConfigurable && verticalName) {
      return (
        <CreateNewLineDrug searchName={searchName} jobId={jobId} vertical={verticalName} appId={fieldConfigurable.ID} />
      );
    }

    const props = {
      jobId,
      searchName,
      verticalId,
      verticalName,
      fromPage,
      sRaName,
    };
    switch (verticalId) {
      case VERTICALS.FLIGHTS:
        return <CreateNewLineItem {...props} addLineItem={addLineItem} />;
      case VERTICALS.CARS:
        return <CreateNewLineCar addLineItem={addLineItem} {...props} />;
      case VERTICALS.HOTELS:
        return <CreateNewLineHotel {...props} />;
      case VERTICALS.VACATION:
        return <CreateNewLineVacation {...props} />;
      case VERTICALS.FERRY:
        return <CreateNewLineFerry {...props} />;
      case VERTICALS.CRUISES:
        return <CreateNewLineCruise {...props} />;
      case VERTICALS.SOLUTIONS:
        return <CreateNewLineSolution {...props} />;
      case VERTICALS.CYBERPRICE:
        return <CreateNewLineCyberPrice {...props} />;
      case VERTICALS.AUTOPARTSRA:
        return <CreateNewLineAutopart {...props} />;
      case VERTICALS.AUDIOBOOK:
        return <CreateNewLineAutopart {...props} />;
      case VERTICALS.HOMEGOODS:
        return <CreateNewLineAutopart {...props} />;
      case VERTICALS.HOMEIMPROVEMENT:
        return <CreateNewLineAutopart {...props} />;
      case VERTICALS.RA:
        return <CreateNewLineAutopart {...props} />;
    }
  };

  return (
    <>
      {fields.length === 0 && <Spin spinning={true} />}
      {fields.length > 0 && getSearchWidget(verticalIdN, verticalName, fields)}
    </>
  );
};

export default CreateNewLineView;
